import links from "@/links/links";
import qs from "qs";

export default {
  actions: {
    // NOTE: get only the ones that belong to current building
    FETCH(buildingId) {
      return this.get(links.BUILDING_LOT_FETCH(buildingId), {
        dataKey: "hydra:member",
      });
    },
    GET(id) {
      return this.get(links.BUILDING_LOT_GET(id));
    },
    // NOTE: create + attach building owner (create entry in join table building_owner_building_lot) ???: ..
    POST(item) {
      return this.post(links.BUILDING_LOT_POST(), item);
    },
    PUT(item) {
      return this.put(links.BUILDING_LOT_PUT(item.id), item);
    },
    DELETE(item) {
      return this.delete(links.BUILDING_LOT_DELETE(item.id), {
        delete: item.id,
      });
    },
    REGISTER_GET_BUILDING_LOTS(meetingId) {
      let params = {};
      if (meetingId) {
        params["meeting_id"] = meetingId;
      }
      return this.get(links.BUILDING_LOT_MEETING_REGISTER() + "?" + qs.stringify(params));
    },
  },
};
